<script setup lang="ts">
/**
 * ErrorState — something went wrong (or isn't there): a PeekNote (her peek_cat
 * looking in from the note's corner, its cut edges past the note's edges). `retryable` adds a "try again" button (emits
 * `retry`); leave it off for states that can't be retried (not found).
 */
import { useI18n } from 'vue-i18n';
import { Button } from '@/components/ui/button';
import PeekNote from '../paper/PeekNote.vue';

defineProps<{ title?: string; caption?: string; retryable?: boolean }>();
const emit = defineEmits<{ (e: 'retry'): void }>();

const { t } = useI18n();
</script>

<template>
  <PeekNote
    class="mx-auto w-full max-w-sm"
    role="alert"
  >
    <h2 class="type-app-heading mb-1.5">{{ title ?? t('error.load.title') }}</h2>
    <p class="type-caption">{{ caption ?? t('error.load.caption') }}</p>
    <Button
      v-if="retryable"
      variant="secondary"
      class="mt-5"
      @click="emit('retry')"
    >
      {{ t('error.load.retry') }}
    </Button>
  </PeekNote>
</template>
